import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import HealthKeeperRedirectScreen from './containers/HealthKeeperRedirectScreen';
import myPrivilegesSaga from './sagas/myPrivilegesSaga';
import healthKeeperSaga from './sagas/healthKeeperSaga';
import myPrivilegesCardViewRegistry from '../../registries/MyPrivilegesCardViewRegistry';
import WellnessCompanionMyPrivilegesCardView from './containers/MyPrivilegesCardView';
import WellnessCompanionMyPrivilegesDetailsView from './containers/MyPrivilegesDetailsView';
import HealthKeeperRedirectLoadingScreen from './containers/HealthKeeperRedirectLoadingScreen';
import { withLoadingWidgetHoc } from '../../components/lazyLoading/with-loading-widget-hoc';
myPrivilegesCardViewRegistry.register(
  config.id,
  WellnessCompanionMyPrivilegesCardView,
  WellnessCompanionMyPrivilegesDetailsView,
  false,
  config.myPrivigesReducerSubName,
);
myPrivilegesCardViewRegistry.register(
  config.disabledId,
  WellnessCompanionMyPrivilegesCardView,
  WellnessCompanionMyPrivilegesDetailsView,
  true,
  config.myPrivigesReducerSubName,
);
myPrivilegesCardViewRegistry.register(
  config.lockedId,
  WellnessCompanionMyPrivilegesCardView,
  WellnessCompanionMyPrivilegesDetailsView,
  true,
  config.myPrivigesReducerSubName,
);

export default {
  config,
  routes: {
    '/redirect': {
      exact: true,
      container: withLoadingWidgetHoc(HealthKeeperRedirectScreen),
    },
    '/wellness-companion-redirect': {
      exact: true,
      container: withLoadingWidgetHoc(HealthKeeperRedirectLoadingScreen),
    },
  },
  sagas: [myPrivilegesSaga, healthKeeperSaga],
} as ModuleConfig;
